/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AfterFCBonusType {
  DOUBLE_DEPOSIT = "DOUBLE_DEPOSIT",
  NONE = "NONE",
  SALE_50_PERCENT = "SALE_50_PERCENT",
}

/**
 * Точка, из которой клиент переключил тумблер.
 */
export enum AutoRenewalSource {
  IN_CALL = "IN_CALL",
  PROFILE = "PROFILE",
}

export enum AutoRenewalStatus {
  FAILED = "FAILED",
  IN_PROGRESS = "IN_PROGRESS",
  NONE = "NONE",
  SUCCEEDED = "SUCCEEDED",
}

export enum BillingEventType {
  bonus = "bonus",
  bonus_affiliate = "bonus_affiliate",
  bonus_referral = "bonus_referral",
  chat_session = "chat_session",
  correction = "correction",
  payment = "payment",
  phone_session = "phone_session",
  product = "product",
  video_session = "video_session",
}

export enum BonusFormula {
  fixed = "fixed",
  percent = "percent",
}

export enum CardType {
  AmericanExpress = "AmericanExpress",
  Belcard = "Belcard",
  Maestro = "Maestro",
  Mastercard = "Mastercard",
  Mir = "Mir",
  Troy = "Troy",
  Unknown = "Unknown",
  VISA = "VISA",
}

export enum CashbackType {
  freeMinutes = "freeMinutes",
  money = "money",
}

export enum Currency {
  EUR = "EUR",
  RUB = "RUB",
  USD = "USD",
}

export enum ExpertCategory {
  Bronze = "Bronze",
  Diamond = "Diamond",
  Exclusive = "Exclusive",
  Gold = "Gold",
  New = "New",
  Platinum = "Platinum",
  Silver = "Silver",
  default = "default",
}

export enum ExpertDisplayStatus {
  visible_false = "visible_false",
  visible_for_admin = "visible_for_admin",
  visible_for_all = "visible_for_all",
  visible_for_avito_users_only = "visible_for_avito_users_only",
}

export enum ExpertServicesSortBy {
  PRIORITY = "PRIORITY",
}

export enum ExpertState {
  available = "available",
  busy = "busy",
  offline = "offline",
}

export enum ExpertStateNew {
  available = "available",
  busy = "busy",
  offline = "offline",
}

export enum Gender {
  CUSTOM = "CUSTOM",
  FEMALE = "FEMALE",
  MALE = "MALE",
  UNKNOWN = "UNKNOWN",
}

export enum LobbyExpertSortBy {
  EXPERT_CREATED_AT = "EXPERT_CREATED_AT",
  LAST_SESSION_DATE = "LAST_SESSION_DATE",
  RATE = "RATE",
}

export enum OrderEnum {
  asc = "asc",
  desc = "desc",
}

export enum PaymentButtonType {
  moneyOnly = "moneyOnly",
  moneyWithMinutes = "moneyWithMinutes",
}

export enum PaymentError {
  CommonError = "CommonError",
  DeclinedBy3DSCheck = "DeclinedBy3DSCheck",
  IncorrectPAN = "IncorrectPAN",
  IncorrectPINOrCVV = "IncorrectPINOrCVV",
  InsufficientFundsOnBalance = "InsufficientFundsOnBalance",
  NoError = "NoError",
}

export enum PaymentFormType {
  appointment = "appointment",
  profile = "profile",
  session = "session",
}

export enum PaymentLocation {
  appointment = "appointment",
  fix_from_profile = "fix_from_profile",
  profile = "profile",
  session = "session",
}

export enum PaymentOption {
  ForeignCardV2 = "ForeignCardV2",
  RussianCard = "RussianCard",
}

export enum PaymentProvider {
  CloudPayments = "CloudPayments",
  Other = "Other",
  RobokassaPayments = "RobokassaPayments",
  SoftlinePayments = "SoftlinePayments",
  SomPayments = "SomPayments",
}

export enum PaymentState {
  Created = "Created",
  Failed = "Failed",
  InProgress = "InProgress",
  Refunded = "Refunded",
  Success = "Success",
}

export enum ProductType {
  bonus = "bonus",
  gift = "gift",
  service = "service",
}

export enum QuizName {
  CHEATING = "CHEATING",
  DIVORCE = "DIVORCE",
  RELATIONSHIPS_CRISIS = "RELATIONSHIPS_CRISIS",
}

export enum QuizStepType {
  CHOICE = "CHOICE",
  QUESTION = "QUESTION",
}

export enum ScheduleStatus {
  ScheduleStatusCompleted = "ScheduleStatusCompleted",
  ScheduleStatusInProgress = "ScheduleStatusInProgress",
  ScheduleStatusScheduled = "ScheduleStatusScheduled",
  ScheduleStatusUnknown = "ScheduleStatusUnknown",
}

export enum ScheduleType {
  ScheduleTypePrivate = "ScheduleTypePrivate",
  ScheduleTypePublic = "ScheduleTypePublic",
  ScheduleTypeUnknown = "ScheduleTypeUnknown",
  ScheduleTypeWorkshop = "ScheduleTypeWorkshop",
}

export enum SessionEndReason {
  backend_reason = "backend_reason",
  billing_prohibition = "billing_prohibition",
  call_failed = "call_failed",
  call_start_fail = "call_start_fail",
  callee_no_answer = "callee_no_answer",
  callee_rejected = "callee_rejected",
  callee_unavailable = "callee_unavailable",
  caller_cancelled = "caller_cancelled",
  ended_by_admin = "ended_by_admin",
  ended_by_client = "ended_by_client",
  ended_by_cron_waiting = "ended_by_cron_waiting",
  ended_by_expert = "ended_by_expert",
  expert_side_call_is_not_answered_within_60_seconds = "expert_side_call_is_not_answered_within_60_seconds",
  expert_side_call_is_rejected = "expert_side_call_is_rejected",
  expert_side_call_was_not_answered_within_60_seconds = "expert_side_call_was_not_answered_within_60_seconds",
  expert_side_call_was_rejected = "expert_side_call_was_rejected",
  expert_side_destination_number_is_busy = "expert_side_destination_number_is_busy",
  expert_side_destination_number_is_unavailable = "expert_side_destination_number_is_unavailable",
  expert_side_detected_normal_call_end = "expert_side_detected_normal_call_end",
  expert_side_detected_request_disconnected_by_expert_side = "expert_side_detected_request_disconnected_by_expert_side",
  expert_side_detected_request_terminated_by_user_side = "expert_side_detected_request_terminated_by_user_side",
  expert_side_insufficient_funds = "expert_side_insufficient_funds",
  expert_side_invalid_number = "expert_side_invalid_number",
  expert_to_user_call_failed = "expert_to_user_call_failed",
  not_ended = "not_ended",
  unknown = "unknown",
  user_side_call_is_not_answered_within_60_seconds = "user_side_call_is_not_answered_within_60_seconds",
  user_side_call_is_rejected = "user_side_call_is_rejected",
  user_side_call_was_not_answered_within_60_seconds = "user_side_call_was_not_answered_within_60_seconds",
  user_side_call_was_rejected = "user_side_call_was_rejected",
  user_side_destination_number_is_busy = "user_side_destination_number_is_busy",
  user_side_destination_number_is_unavailable = "user_side_destination_number_is_unavailable",
  user_side_detected_normal_call_end = "user_side_detected_normal_call_end",
  user_side_detected_request_disconnected_by_user_side = "user_side_detected_request_disconnected_by_user_side",
  user_side_detected_request_terminated_by_expert_side = "user_side_detected_request_terminated_by_expert_side",
  user_side_insufficient_funds = "user_side_insufficient_funds",
  user_side_invalid_number = "user_side_invalid_number",
  vats_to_expert_call_failed = "vats_to_expert_call_failed",
  voice_mail_detected = "voice_mail_detected",
}

export enum SessionStatus {
  ended = "ended",
  ended_with_review = "ended_with_review",
  failed = "failed",
  in_progress = "in_progress",
  waiting = "waiting",
}

export enum SessionType {
  CHAT = "CHAT",
  PHONE_CALL = "PHONE_CALL",
  VIDEO_CALL = "VIDEO_CALL",
}

export enum SortByEnum {
  date = "date",
  default = "default",
  id = "id",
  rate = "rate",
  rating = "rating",
}

export enum SortOrder {
  ASC = "ASC",
  DESC = "DESC",
}

export enum WbOfferStatus {
  ACTIVE = "ACTIVE",
  AVAILABLE = "AVAILABLE",
  COMPLETED = "COMPLETED",
}

export enum operationType {
  balance = "balance",
  product = "product",
}

export interface CalculateCashbackInput {
  paymentAmount: number;
}

export interface ChangeEmailInput {
  email: string;
}

export interface DateFilterS {
  earlierThan?: any | null;
  laterThan?: any | null;
}

export interface ExpertFilter {
  scopes?: number[] | null;
  onlineOnly?: boolean | null;
  skills?: number[] | null;
  gender?: Gender | null;
  maxRate?: number | null;
  sessionType?: SessionType[] | null;
  displayStatus?: ExpertDisplayStatus | null;
}

export interface ExpertServicesFilter {
  expertIDs?: string[] | null;
}

export interface ExpertServicesSortInput {
  sortBy: ExpertServicesSortBy;
  order: SortOrder;
}

export interface GetAfterFreeConsultationBonusInput {
  userID: string;
}

export interface GetExpertServicesInput {
  pagination: PaginationParams;
  filter?: ExpertServicesFilter | null;
  sorting?: ExpertServicesSortInput | null;
}

export interface GetLobbyExpertsInput {
  pagination: PaginationParams;
  filter?: LobbyExpertFilter | null;
  sorting?: LobbyExpertSortInput | null;
}

export interface GetPaymentFormDataInput {
  formType: PaymentFormType;
  expertID?: number | null;
  sessionType?: SessionType | null;
}

export interface GetQuizAnswersInput {
  quizName: QuizName;
}

export interface GetScheduleFilter {
  DateFilter?: DateFilterS | null;
  ExpertFilter?: any[] | null;
  displayStatus?: ExpertDisplayStatus | null;
}

export interface GetSessionClientContextInput {
  sessionID: number;
}

export interface LobbyExpertFilter {
  scopes?: number[] | null;
  skills?: number[] | null;
  categories?: ExpertCategory[] | null;
}

export interface LobbyExpertSortInput {
  sortBy: LobbyExpertSortBy;
  order: SortOrder;
}

export interface NewPaymentIn {
  amount: number;
  paymentProvider: PaymentProvider;
  isNeedToSaveCard: boolean;
  link?: string | null;
  location: PaymentLocation;
  relatedID: number;
  paymentOption?: PaymentOption | null;
}

export interface PaginationParams {
  first: number;
  after?: string | null;
}

export interface ProductFilter {
  id?: number | null;
  code?: string | null;
}

export interface PurchaseProductNewCard {
  productID: number;
  paymentProvider: PaymentProvider;
  isNeedToSaveCard?: boolean | null;
  link?: string | null;
  location: PaymentLocation;
  relatedID: number;
}

export interface PurchaseProductSavedCard {
  productID: number;
  cardID: number;
  location: PaymentLocation;
  relatedID: number;
}

export interface SBPPaymentRequest {
  amount: number;
  location: PaymentLocation;
  relatedID: number;
  redirectLink?: string | null;
  operationType: operationType;
  productID?: number | null;
}

export interface SaveQuizStepInput {
  quizName: QuizName;
  step: number;
  type: QuizStepType;
  title: string;
  value: string;
}

export interface SaveRefererInput {
  referer: string;
  eventType: string;
  sessionID?: number | null;
  paymentID?: number | null;
}

export interface SaveUserCookieChoiceInput {
  settings: string;
}

export interface SessionFilter {
  minDurationInMinutes?: number | null;
  maxDurationInMinutes?: number | null;
}

export interface SortParameters {
  sortBy: SortByEnum;
  order: OrderEnum;
}

export interface UpdAutoRenewalSettings {
  enabled: boolean;
  source: AutoRenewalSource;
  agreementVersion?: string | null;
}

export interface UpdMailingSettings {
  general: boolean;
  lunary: boolean;
  trigger: boolean;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
